import DataService from "../../../services/client/classes/dataService";
import { IFilterApplicationList } from '../models/interfaces/applicationTrackingSystem/iFilterApplicationList'
import { IChangeApplicationStatusOutput } from "../models/interfaces/applicationTrackingSystem/iChangeApplicationStatusOutput";
import { ISearchFilter } from "../models/interfaces/searchAndDiscovery/iSearchFilter";
import { IDiscoveryFilter } from "../models/interfaces/searchAndDiscovery/iDiscoveryFilter";

class SearchAndDiscoveryService extends DataService {
    constructor() {
    super('/private/database/searchAndDiscovery/');
    }

  getNonprofitsBySearchFilter(searchFilter: ISearchFilter): JQuery.jqXHR<any> {
    return this.post('getNonprofitsBySearchFilter/', searchFilter);
  }

  getNonprofitsByDiscoveryFilter(discoveryFilter: IDiscoveryFilter): JQuery.jqXHR<any> {
    return this.post('getNonprofitsByDiscoveryFilter/', discoveryFilter);
    }

}

export default new SearchAndDiscoveryService();



// WEBPACK FOOTER //
// ./static-content/private/javascripts/services/searchAndDiscoveryService.ts